import { createContext } from 'react';
import initialClientsState from './initialClientsState';

const ClientsContext = createContext(initialClientsState);

export default ClientsContext;
